import React from 'react'
import { Dispatch } from 'redux'
import { Formik } from 'formik'
import { PackType, IEditionMetadata } from '../../types/pack'
import { IDatafile } from '../../types/datafile'
import { updateDatafile } from '../../actions/datafile'
import { push } from '../../actions/router'
import {
  transformToDatafileFormat,
  transformToDatafileFormInputs,
} from '../../services/datafile'
import { DataFileForm } from '../DataFileForm'
import { dataFileValidationSchema } from '../CreateDataFileForm/validation'

export interface IUpdateDataFileForm {
  edition: IEditionMetadata
  pack: PackType
  datafile: IDatafile
  packFormDirty?: boolean
  dispatch: Dispatch
}

export const UpdateDataFileForm = ({
  edition,
  pack,
  datafile,
  packFormDirty,
  dispatch,
}: IUpdateDataFileForm) => (
  <Formik
    key={edition.modified}
    initialValues={transformToDatafileFormInputs(edition)}
    onSubmit={(values) => {
      dispatch(
        updateDatafile(
          pack.id || '',
          edition.id,
          transformToDatafileFormat(values)
        )
      )
    }}
    render={(formikProps) => (
      <DataFileForm
        formikProps={formikProps}
        datastream={datafile.datastream}
        dataStreamError={datafile.dataStreamError}
        cancelAction={() => {
          formikProps.resetForm()
          dispatch(
            push(
              `/group/${pack.group}/pack/${pack.id}?edition=overall-pack&tab=details`
            )
          )
        }}
        hideFileNameAndTitle
        isFormDisabled={pack.publishing?.publishing}
        packFormDirty={packFormDirty}
      />
    )}
    validationSchema={dataFileValidationSchema}
  />
)
